var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.8143 24H63C66.3138 24 69 26.6863 69 30V42C69 45.3138 66.3138 48 63 48H59.8143C58.338 59.8389 48.2388 69 36 69V63C45.9411 63 54 54.9411 54 45V27C54 17.0589 45.9411 9 36 9C26.0589 9 18 17.0589 18 27V48H9C5.68629 48 3 45.3138 3 42V30C3 26.6863 5.68629 24 9 24H12.1857C13.662 12.1611 23.7611 3 36 3C48.2388 3 58.338 12.1611 59.8143 24ZM9 30V42H12V30H9ZM60 30V42H63V30H60Z",
    fill: "url(#paint0_linear_3318_8357)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 47.0886L26.1804 42C28.9465 43.7325 32.2171 44.7339 35.7217 44.7339C39.2263 44.7339 42.4969 43.7325 45.2629 42L48.4435 47.0886C44.7553 49.3986 40.3945 50.7339 35.7217 50.7339C31.0489 50.7339 26.6881 49.3986 23 47.0886Z",
    fill: "url(#paint1_linear_3318_8357)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3318_8357",
    x1: 3,
    y1: 36,
    x2: 69,
    y2: 36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21B389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3318_8357",
    x1: 31.1486,
    y1: 45.8,
    x2: 53.8481,
    y2: 45.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8C745"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF7B1D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.684618bddeec564fb1faae9b3fabfec9.svg";
export { ForwardRef as ReactComponent };